/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

import { VuetifyColorEnum, VuetifyMaterialColorEnum } from "@/lib/enum/vuetify-color.enum";

/**
 * Enum for status of an invoice
 */
export enum InvoiceStatusEnum {
  ERROR = "error",

  /**
   * The invoice has been created, sort of a draft. It can be modified and sent later. Initial state.
   */
  DRAFT = "draft",

  /**
   * The invoice is created, and ready to be paid.
   */
  OPEN = "open",

  /**
   * The invoice was finalized and billed to the recipient.
   */
  BILLED = "billed",

  /**
   * The invoice was payed to the recipient. End State.
   */
  PAID = "paid",

  /**
   * This invoice is cancelled. End State.
   */
  VOIDED = "voided"
}

/**
 * Vuetify chip color per invoice status. Statuses not in the map (draft) render grey.
 */
export const INVOICE_STATUS_COLOR = new Map<InvoiceStatusEnum, string>([
  [InvoiceStatusEnum.ERROR, VuetifyColorEnum.ERROR],
  [InvoiceStatusEnum.DRAFT, VuetifyMaterialColorEnum.GREY],
  [InvoiceStatusEnum.OPEN, VuetifyColorEnum.PRIMARY],
  [InvoiceStatusEnum.BILLED, VuetifyColorEnum.SUCCESS],
  [InvoiceStatusEnum.PAID, VuetifyColorEnum.SUCCESS],
  [InvoiceStatusEnum.VOIDED, VuetifyMaterialColorEnum.GREY_DARKEN_3]
]);
